import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { ReadMeCard } from '@roadiehq/backstage-plugin-github-insights';

export const entityContentReadme: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'readme',
    params: {
      path: '/readme',
      title: 'Readme',
      loader: async () => <ReadMeCard />,
    },
  });
